<template>
  <div>
    <Navbar />
    <section class="bg-home bg-light d-flex align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="text-center" v-if="isProcessing">
              <div
                class="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                style="height: 90px; width: 90px"
              >
                <i class="uil uil-clock align-middle h1 mb-0"></i>
              </div>
              <h1 class="my-4 font-weight-bold">{{ $t(msg) }}</h1>
              <p class="text-muted para-desc mx-auto">
                {{ $t("auth:activate_email.process") }}
              </p>
            </div>
            <div class="text-center" v-else-if="activated">
              <div
                class="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                style="height: 90px; width: 90px"
              >
                <i class="uil uil-thumbs-up align-middle h1 mb-0"></i>
              </div>
              <h1 class="my-4 font-weight-bold">{{ $t(msg) }}</h1>
              <p data-test="email-activated-msg" class="text-muted para-desc mx-auto">
                {{ $t("auth:activate_email.found") }}
              </p>
            </div>
            <div class="text-center" v-else>
              <div
                class="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                style="height: 90px; width: 90px"
              >
                <i class="uil uil-thumbs-down align-middle h1 mb-0"></i>
              </div>
              <h1 class="my-4 font-weight-bold">{{ $t(msg) }}</h1>
              <p class="text-muted para-desc mx-auto">
                {{ $t("auth:activate_email.not_found") }}
              </p>
              <router-link to="/" class="btn btn-soft-primary mt-3">{{
                $t("auth:activate_email.home")
              }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import HttpClientFactory from "../services/HttpClientFactory";
import Navbar from "@/components/landing_landrick/navbar";
import Footer from "@/components/landing_landrick/footer";
export default {
  name: "ActivateEmail",
  data() {
    return {
      msg: "",
      activated: false,
      isProcessing: false
    };
  },
  components: {
    Navbar,
    Footer
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
    const sendData = {
      token: this.$route.query.token
    };
    this.msg = "auth:activate_email.process_confirm";
    this.isProcessing = true;
    this.activated = false;
    setTimeout(
      () =>
        this.httpClient
          .post(
            process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/activate",
            sendData
          )
          .then(() => {
            this.msg = "auth:activate_email.activated";
            this.isProcessing = false;
            this.activated = true;
            setTimeout(() => this.$router.push("login"), 2000);
          })
          .catch(() => {
            this.isProcessing = false;
            this.activated = false;
            this.msg = "auth:activate_email.error_found";
          }),
      2000
    );
  }
};
</script>
